import React, { memo, useCallback, useMemo } from "react";
import { NodeProps } from "reactflow";
import { NodeData, NodeType } from "../../../models/nodeType";
import BaseNode from "../../../features/reactflow/nodes/base/BaseNode";
import { useForm } from "react-hook-form";
import {
  FormControl,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import SelectSkill from "../../base/SelectSkill";

interface SkillAndLevels extends NodeData {
  skillId: string;
  levels: number;
}

const SkillAndLevelsNode: React.FC<NodeProps<NodeType<SkillAndLevels>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const skillId = nodeData?.skillId;
  const levels = nodeData?.levels;

  const { register, getValues, setValue, handleSubmit } = useForm<SkillAndLevels>({
    defaultValues: useMemo(
      () => ({
        skillId,
        levels,
      }),
      [skillId, levels]
    ),
    mode: "onChange",
  });

  const { updateNodeData } = useUpdateNodeData(nodeId);

  const handleUpdate = useCallback(
    (skillAndLevel: SkillAndLevels) => {
      updateNodeData(skillAndLevel);
    },
    [updateNodeData]
  );

  return (
    <BaseNode {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
        <Stack p={2}>
          <SelectSkill color={color} value={getValues("skillId")} setValue={(value) => setValue("skillId", value)} />

          <FormControl>
            <FormLabel>
              <Text color={color} casing={"uppercase"}>
                Levels
              </Text>
            </FormLabel>
            <NumberInput step={1} defaultValue={0} min={0}>
              <NumberInputField color={color} {...register("levels")} />
              <NumberInputStepper>
                <NumberIncrementStepper color={color} />
                <NumberDecrementStepper color={color} />
              </NumberInputStepper>
            </NumberInput>
          </FormControl>
        </Stack>
      </form>
    </BaseNode>
  );
};

export default memo(SkillAndLevelsNode);
